var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94081 2.78282C9.98223 1.7414 11.6707 1.74142 12.7121 2.78286L13.2171 3.28784C14.2584 4.32926 14.2584 6.01768 13.217 7.05906L7.51754 12.7584C7.18592 13.09 6.77271 13.3283 6.3196 13.4492L4.51784 13.9301C3.03203 14.3267 1.67323 12.9679 2.06973 11.4821L2.55055 9.68026C2.67148 9.22709 2.90979 8.81384 3.24144 8.48219L8.94081 2.78282ZM11.7693 3.72565C11.2486 3.20493 10.4043 3.20492 9.88362 3.72563L9.27604 4.33321L11.6666 6.72379L12.2742 6.11624C12.7949 5.59555 12.7949 4.75134 12.2742 4.23063L11.7693 3.72565ZM5.27604 8.33321L8.33323 5.27602L10.7238 7.66659L7.66658 10.7238L5.27604 8.33321ZM4.33323 9.27602L4.18425 9.425C4.01842 9.59083 3.89927 9.79745 3.8388 10.024L3.35798 11.8259C3.22581 12.3211 3.67875 12.774 4.17402 12.6419L5.97577 12.161C6.20233 12.1005 6.40893 11.9814 6.57474 11.8156L6.72376 11.6665L4.33323 9.27602Z",
    fill: "#009866"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilGreen);
export default __webpack_public_path__ + "static/media/pencil_green.1f261954ed02150ee576f407975cf214.svg";
export { ForwardRef as ReactComponent };